import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IgenomicsState } from '../../../../core/interfaces/genomics-state.interface';
import { Store } from '@ngrx/store';
import { IDiagnosticOrder } from '../../interfaces/diagnostic-order.interface';
import { Observable } from 'rxjs/Observable';
import { HttpInterceptorService } from '../../../../core/services/http-interceptor.service';
import { map, filter } from 'rxjs/operators';
import { RouterManagerService } from '@ispm/core/services/router-manager.service';

const RESULTS_PATH = 'oncoSignal/results';

@Component({
  selector: 'gen-technical-info',
  templateUrl: './technical-info.component.html',
  styleUrls: ['./technical-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TechnicalInfoComponent implements OnInit {
  diagnosticOrder$: Observable<IDiagnosticOrder>;

  readonly pcrRunTitle = 'PCR Run Info';
  readonly pcrRunFields = [
    {'value': 'file.uploadedFile.name', 'cssClass': 'wordBreak'},
    {'value': 'file.uploadedFile.size'},
    {'value': 'file.uploadedFile.pcrDate'},
    {'value': 'file.uploadedFile.publisher'},
    {'value': 'file.uploadedFile.instrument'},
    {'value': 'file.uploadedFile.software'}];

  thermalWarning$: Observable<boolean>;
  readonly thermalWarningMessage = 'Deviation in PCR protocol is detected, please consider that this might lead to ' +
    'inaccurate results. Please consult the executing technician or the OncoSignal team.';


  public reactDataList$: Observable<string[]>; // TODO: Everything that has to do with this needs to move to a service/state shared between this and the results tab.

  constructor(private store: Store<IgenomicsState>, private http: HttpInterceptorService, private routerManagerService: RouterManagerService) {
  }

  ngOnInit() {
    this.reactDataList$ = this.http.get(RESULTS_PATH, { revisionId: this.routerManagerService.parameters?.revisionId})
      .map(reponse => reponse.body[0])
      .map(signalResults => signalResults.pcrData.reactDataList)
      .publishReplay(1)
      .refCount();
    this.diagnosticOrder$ = this.store.select('tests', 'diagnosticOrders', 'order')
      .filter(order => !!order);
    this.thermalWarning$ = this.diagnosticOrder$.pipe(filter(order => order.hasOwnProperty('file')),
      map((order: any) => order.file.uploadedFile.warning)); // any is required here due to extension of diagnostic order.
  }

}
